import { recentProfessionalsAdapter } from './recentProfessionalsAdapter';
import { IGetRecentProfessionalsParams, recentProfessionalsApi } from './recentProfessionalsApi';
import { IRecentProfessional } from './recentProfessionalsTypes';

async function getRecentProfessionals(
  params: IGetRecentProfessionalsParams,
): Promise<IRecentProfessional[]> {
  const recentProfessionalsAPI = await recentProfessionalsApi.getRecentProfessionals(params);

  return recentProfessionalsAPI.map(recentProfessionalsAdapter.toRecentProfessional);
}

export const recentProfessionalsService = {
  getRecentProfessionals,
};
